import { render, staticRenderFns } from "./AirLeeCustomerLogin.vue?vue&type=template&id=0c2f4d47&scoped=true&"
import script from "./AirLeeCustomerLogin.vue?vue&type=script&lang=js&"
export * from "./AirLeeCustomerLogin.vue?vue&type=script&lang=js&"
import style0 from "./AirLeeCustomerLogin.vue?vue&type=style&index=0&id=0c2f4d47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2f4d47",
  null
  
)

export default component.exports